(function() {
    'use strict';

    angular.module('machine')
        .controller('MachineUpdateController', MachineUpdateController);

    MachineUpdateController.$inject = ['$state', '$uibModal', 'machineDataSrvc', 'notificationSrvc', 'machineMessagesConst', 'machineactionPermissionsConst', 'checkModelPermissionsSrvc', 'errorNotificationSrvc'];

    function MachineUpdateController($state, $uibModal, machineDataSrvc, notificationSrvc, machineMessagesConst, machineactionPermissionsConst, checkModelPermissionsSrvc, errorNotificationSrvc) {
        var self = this;

        self.loading = true;

        self.serverErrors = {
            name: [],
            model: [],
            type: [],
            image: [],
            nonFieldErrors: []
        };
        self.machineData = {};

        self.updateMachine = updateMachine;
        self.cleanErrors = cleanErrors;

        self.actionCols = [{
            title: 'Nazwa',
            value: 'name',
            type: 'text'
        }, {
            title: 'Podgląd pracy',
            value: 'is_work_preview',
            type: 'boolean'
        }, {
            title: 'Informacje o montażu',
            value: 'is_mounting_info',
            type: 'boolean'
        }, {
            title: 'Weryfikacja kodów użytków',
            value: 'is_use_codes_verification',
            type: 'boolean'
        }, {
            title: 'Drukowanie i weryfikacja kodów użytków',
            value: 'is_use_codes_verification_print',
            type: 'boolean'
        }, {
            title: 'Weryfikacja kodu montażu',
            value: 'is_assembly_codes_verification',
            type: 'boolean'
        }];
        self.modelPermissions = machineactionPermissionsConst;

        self.hasMachineActionViewPermission = hasMachineActionViewPermission;
        self.onActionCreate = onActionCreate;
        self.onActionEdit = onActionEdit;
        self.onActionDelete = onActionDelete;
        self.onActionReorder = onActionReorder;

        activate();

        function activate() {
            getMachine();
        }

        function getMachine() {
            self.loading = true;

            return machineDataSrvc.get({
                pk: $state.params.pk
            }).$promise.then(function(response) {
                self.machineData = response;

                if (!self.machineData.actions.length) {
                    self.machineData.actions.length = [];
                }

                delete self.machineData.date_modified;
                delete self.machineData.date_added;
                return response;
            }).finally(function(response) {
                self.loading = false;
            });
        }

        function updateMachine() {
            return machineDataSrvc.update({
                pk: self.machineData.pk
            }, self.machineData).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", machineMessagesConst.update);
                    $state.go('layout.machine.list');
                    return response;
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }

        function hasMachineActionViewPermission() {
            return !checkModelPermissionsSrvc.isDenied(
                machineactionPermissionsConst.view);
        }

        function onActionCreate() {
            $uibModal.open({
                templateUrl: 'app/machine/views/machine-action-create/machine-action-create.html',
                controller: 'MachineActionCreateController',
                controllerAs: 'ctrl'
            }).result.then(
                function(result) {
                    self.machineData.actions.unshift(result);
                }
            );
        }

        function onActionEdit(row) {
            $uibModal.open({
                templateUrl: 'app/machine/views/machine-action-update/machine-action-update.html',
                controller: 'MachineActionUpdateController',
                controllerAs: 'ctrl',
                resolve: {
                    row: function() {
                        return row;
                    }
                }
            }).result.then(
                function(result) {
                    var index = self.machineData.actions.indexOf(row);
                    self.machineData.actions[index] = result;
                }
            );
        }

        function onActionDelete(row) {
            var index = self.machineData.actions.indexOf(row);
            self.machineData.actions.splice(index, 1);
        }

        function onActionReorder(row, newPos) {
            row.position = newPos;
            machineDataSrvc.update({
                pk: self.machineData.pk
            }, {
                actions: self.machineData.actions
            }).$promise.then(
                function(response) {
                    return response;
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }
    }
})();
